import ContainerBlockGenericType from "../ContainersBlocks/ContainerBlockGenericType";

function MBX
    ({ id, isConnectable, type, selected }) {
    return (
        <ContainerBlockGenericType
            id={id}
            isConnectable={isConnectable}
            type={type}
            selected={selected}
            flagNumber={42}
            showLabelInput={true}
            openModalProp={true}
            userConfiguration={true}
        />
    );
}
export default MBX